export const QuickLink = ({ text, handleClick }) => (
  <div className='quick-link-wrapper'>
    <button className='quick-link' onClick={handleClick}>
      {text}
    </button>
  </div>
);
